import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/images/logo-sm.png';
import _imports_1 from '@/assets/images/logo-light.png';
const _hoisted_1 = {
  class: "ck-brand"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  class: "logo-icon"
}, null, -1);
const _hoisted_3 = {
  src: _imports_1,
  alt: "Tracker",
  class: "logo-text"
};
const _hoisted_4 = ["title"];
const _hoisted_5 = {
  class: "ck-nav"
};
const _hoisted_6 = ["src", "title"];
const _hoisted_7 = {
  class: "ck-body"
};
const _hoisted_8 = {
  class: "ck-topbar d-print-none"
};
const _hoisted_9 = {
  class: "ck-page"
};
import NavBarComp from '@/components/nav-bar.vue';
import usePlanPrice from '@/composable/plan-price';
import useLayouts from '@/composable/layout';
import { ref } from 'vue';
export default {
  __name: 'Admin',
  setup(__props) {
    const {
      tenantInfo
    } = usePlanPrice();
    const {
      isCollapse,
      toggleSidebar
    } = useLayouts();
    const isMobileOpen = ref(false);
    function handleToggle() {
      toggleSidebar(!isCollapse.value);
    }
    function goToExternalSite() {
      if (tenantInfo?.value?.website) window.open(tenantInfo.value.website, '_blank');
    }
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_Menu = _resolveComponent("Menu");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass(["ck-overlay", {
          active: isMobileOpen.value
        }]),
        onClick: _cache[0] || (_cache[0] = $event => isMobileOpen.value = false)
      }, null, 2), _createElementVNode("div", {
        class: _normalizeClass(["ck-layout", {
          collapsed: _unref(isCollapse)
        }])
      }, [_createElementVNode("aside", {
        class: _normalizeClass(["ck-sidebar d-print-none", {
          open: isMobileOpen.value
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_router_link, {
        to: "/dashboard",
        class: "ck-logo"
      }, {
        default: _withCtx(() => [_hoisted_2, _withDirectives(_createElementVNode("img", _hoisted_3, null, 512), [[_vShow, !_unref(isCollapse)]])]),
        _: 1
      }), _createElementVNode("button", {
        class: "collapse-btn d-none d-md-flex",
        onClick: handleToggle,
        title: _unref(isCollapse) ? 'Expand sidebar' : 'Collapse sidebar'
      }, [_createElementVNode("i", {
        class: _normalizeClass(["bx", _unref(isCollapse) ? 'bx-chevrons-right' : 'bx-chevrons-left'])
      }, null, 2)], 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_scrollbar, null, {
        default: _withCtx(() => [_createVNode(_component_Menu)]),
        _: 1
      })]), _unref(tenantInfo)?.logo ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "ck-tenant-foot",
        onClick: goToExternalSite
      }, [_createElementVNode("img", {
        src: _unref(tenantInfo).logo,
        class: "tenant-img",
        title: _unref(tenantInfo)?.tenant_name
      }, null, 8, _hoisted_6), _withDirectives(_createElementVNode("span", {
        class: "tenant-label"
      }, _toDisplayString(_unref(tenantInfo)?.tenant_name), 513), [[_vShow, !_unref(isCollapse)]])])) : _createCommentVNode("", true)], 2), _createElementVNode("div", _hoisted_7, [_createElementVNode("header", _hoisted_8, [_createVNode(NavBarComp, {
        onMobileToggle: _cache[1] || (_cache[1] = $event => isMobileOpen.value = !isMobileOpen.value)
      })]), _createElementVNode("main", _hoisted_9, [_renderSlot(_ctx.$slots, "default")])])], 2)], 64);
    };
  }
};